import '../style/cell.scss'
import { isFunction } from 'lodash'
import { CELL_PROPS } from '../props/cell'

function iconClass (btn) {
  let cls = (typeof btn.class === 'function') ? btn.class() : (btn.class || '')
  let icon = btn.icon ? (/^icon\w+\s+icon-/.test(btn.icon) ? btn.icon : 'iconfont icon-' + btn.icon) : ''
  // 2021-09-01 由于public仓库图标冲突，转到layout图标仓库兼容
  let layoutIcon = ['export', 'import', 'custom', 'minus', 'plus', 'search', 'reset', 'delete', 'pen']
  if (btn.icon && !/^icon\w+\s+icon-/.test(btn.icon) && layoutIcon.includes(btn.icon)) {
    icon = `layout layout-${btn.icon === 'search' ? 'search1' : btn.icon}`
  }
  return `${cls} ${icon}`
}

export default {
  props: CELL_PROPS,
  render (h) {
    const props = this.$props
    const [$slots] = this.$slots.default

    const {
      label,
      value,
      checked,
      draggable,
      showDraggableIcon,
      render,
      showCheckbox,
      key,
      icon,
      auth,
      disabled,
      valueStyle = {},
      labelStyle = {}
    } = props.item
    if (!key) {
      throw Error('key必须存在')
    }
    const isCustomRender = render || $slots.cell
    // 单选标识
    const selected = props.selectedKey && props.selectedKey === key && !isCustomRender

    const pureDisplay = this.$props.selectMode === 'none'
    // class
    const wrapClass = {
      'kye-data-statistic-cell': true,
      checked: !props.showCheckbox && selected,
      undraggable: props.item.hasOwnProperty('draggable') ? (isFunction(draggable) ? !draggable(props) : draggable === false) : props.draggable === false,
      'custom-render': isCustomRender,
      'more-btn-wrap': this.$props.type === 'option'
    }
    let content = null
    if (render && isFunction(render)) {
      // render优先级最高
      content = () => render(h, props)
    } else if ($slots.cell) {
      // 然后是插槽
      content = () => isFunction($slots.cell) ? $slots.cell(props) : $slots.cell
    } else {
      // 默认的支持
      content = () => {
        return [
          showDraggableIcon ? <i
            class="icon"
            on-click={e => e.stopPropagation()}
          ></i> : null,
          showCheckbox === false ? null : (props.showCheckbox ? <kye-checkbox
            class="checkbox"
            value={checked}
            disabled={isFunction(disabled) ? disabled(props) : !!disabled}
            on-change={(val, e) => {
              props.handleChangeCheckbox(val, props)
            }}
          ></kye-checkbox> : null),
          label || icon || (value !== null || value !== undefined) ? <kye-button
            type="text"
            icon={iconClass(props.item)}
            auth={isFunction(auth) ? auth(props) : auth}
            disabled={isFunction(disabled) ? disabled(props) : !!disabled}
            class={{'pure-display': pureDisplay}}
            on-click={e => {
              if (this.$props.showCheckbox || pureDisplay) {
                return
              }
              props.handleEvent(e, {eventName: 'data-statistic-cell-click', ...props})
            }}
          >
            <span
              class="label"
              style={labelStyle}
              on-click={e => {
                props.handleEvent(e, {eventName: 'data-statistic-cell-label-click', ...props})
              }}
            >{label}</span>
            <span
              class="value"
              style={valueStyle}
              on-click={e => {
                props.handleEvent(e, {eventName: 'data-statistic-cell-value-click', ...props})
              }}
            >{value}</span>
          </kye-button> : null,
        ]
      }
    }
    return <div
      class={wrapClass}
      data-key={key}
    >
      {
        content()
      }
    </div>
  },
  mounted () {
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver((entries) => {
        if (entries) {
          this.dispatchSizeChange(entries[0].target)
        }
      })
      this.resizeObserver.observe(this.$el)
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  watch: {
    item () {
      this.$nextTick(() => {
        this.dispatchSizeChange(this.$el)
      })
    }
  },
  methods: {
    getCurrentSize (target) {
      return target ? target['offsetHeight'] : 0
    },
    dispatchSizeChange (target) {
      const currentSize = this.getCurrentSize(target)
      const { key } = this.$props.item
      currentSize && this.$props.resizeCellHeight(this.$props.type, key, currentSize)
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/component/cell.js